import { ImisFormWebhookResponse } from "../../models/imis.models";

/** Static utility namespace for building the response object and message log returned to an iMIS form-builder webhook. */
export class FormWebhooksUtility {
    /**
     * Creates a new default webhook response object, indicating success with an empty message.
     * @returns A new `ImisFormWebhookResponse` with `result` set to `true` and `message` set to an empty string.
     */
    public static getWebhookResponseObject(): ImisFormWebhookResponse {
        return new ImisFormWebhookResponse();
    }

    /**
     * Marks a webhook response as failed and appends the given error messages to the message log.
     * @param formsWebhookResponse The response object to mark as failed by setting its `result` to `false`.
     * @param formsWebhookMessageLog The running message log to append the errors to.
     * @param errorMessageLog The error messages to add to the message log.
     */
    public static addErrorResponse(formsWebhookResponse: ImisFormWebhookResponse, formsWebhookMessageLog: any[], errorMessageLog: any[]) {
        formsWebhookResponse.result = false;
        errorMessageLog.forEach(function (item) {
            formsWebhookMessageLog.push(item);
        });
    }

    /**
     * Builds the final webhook response message by prepending a success message to any logged error messages (when present) and joining them together.
     * @param formsWebhookMessageLog The accumulated log of error messages, if any.
     * @param successMessage The message to prepend when there are logged errors.
     * @param messageSeparator The string used to join the messages together.
     * @returns The joined message string, or an empty string if the message log is empty.
     */
    public static getWebhookResponseMessage(formsWebhookMessageLog: any[], successMessage: string, messageSeparator: string): string {
        if (formsWebhookMessageLog.length > 0) {
            formsWebhookMessageLog = [successMessage].concat(formsWebhookMessageLog);
        }
        return formsWebhookMessageLog.join(messageSeparator);
    }
}